import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from './app-text.service';

@Pipe({
    name: 'fiAppText',
    standalone: false,
})
export class AppTextPipe implements PipeTransform {
    constructor(private appTextService: AppTextService) {}

    transform(value: string, args?: any): any {
        return this.appTextService.get(value, args);
    }
}
